import { useEffect, useState } from 'react';
import { P2, TextLink } from 'pfm-ui-components';
import styled from 'styled-components';
import GTM from '../../../GTM';
import { up } from 'styled-breakpoints';

interface TimerProps {
  timerDuration: number;
  onResendCode: Function;
  userFlow: string;
}

const ResentText = styled(P2)`
  color: ${(props) => props.theme.palette.grey3};
`;

export default function Timer(props: TimerProps) {
  const { userFlow } = props;
  const [seconds, setSeconds] = useState(props.timerDuration);
  const [shouldShowResend, setshouldShowResend] = useState(false);

  const resendCode = () => {
    GTM.transactInvest.onResendOTP(userFlow);
    // When clicked on RESEND text dislay the timer and set the timer back to original time i.e 30 seconds
    setshouldShowResend(!shouldShowResend);
    setSeconds(props.timerDuration);
    props.onResendCode();
  };

  useEffect(() => {
    // If timer is still counting on and is greater than 0, also if the resend text is not visible in the UI then
    // decrement the timer value every second.
    if (seconds > 0 && !shouldShowResend) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      // If the timer has been completed and now seconds are equal to 0 then set the timer back to original time i.e 30 seconds
      // and show RESEND text to user
      setSeconds(props.timerDuration);
      setshouldShowResend(true);
    }
  });

  useEffect(() => {
    return () => {
      setSeconds(null);
    };
  }, []);

  return (
    <>
      <StyledResendOTPContainer>
        <StyledResendButton shouldShowResend={shouldShowResend} onClick={()=>{
          if(shouldShowResend) resendCode()
        }}>Resend OTP</StyledResendButton>
        {!shouldShowResend ? <StyledResendTimerText>&nbsp;in {seconds < 10 ? '0' + seconds : seconds}&nbsp;seconds</StyledResendTimerText> : ''}
      </StyledResendOTPContainer>
    </>
  );
}

const StyledResendOTPContainer = styled(TextLink)<{shouldShowResend: boolean}>`
display: flex;
justify-content: center;
padding:10px 0px 0px 0px;

${up('md')}{
  justify-content: flex-end;
  padding:5px ${props => !props.shouldShowResend ? "15px" : ""} 0px 0px;
}
`

const StyledResendButton = styled(TextLink)<{shouldShowResend: boolean}>`
color: ${props => props.shouldShowResend ? "#97144d" : "gray"};
font-weight: ${props => props.shouldShowResend ? "700" : "500"};
text-decoration: underline;`

const StyledResendTimerText = styled(TextLink)`
color: gray;`